<div class="onb-grupo-rot">Equipamentos deste computador</div>
<div class="onb-grupo">

  <!-- extensão do WhatsApp -->
  <div class="onb-linha oe-linha">
    <span class="onb-ic oe-ic-whats"><i class="fab fa-whatsapp"></i></span>
    <div class="onb-tx">
      <b>Extensão do WhatsApp</b>
      <span>Com ela, o cliente recebe no WhatsApp cada passo do pedido: aceito, saiu, entregue. Instala no Chrome em 1 minuto.</span>
      <ng-container *ngIf="!extensaoConectada">
        <ol class="oe-passos">
          <li>Toque em <b>Instalar no Chrome</b> e depois em <b>Usar no Chrome</b>.</li>
          <li>Abra o <b>WhatsApp Web</b> com o número da loja<ng-container *ngIf="whatsappLoja">: <b>{{ whatsappLoja }}</b></ng-container>.</li>
          <li>Pronto: esta tela percebe sozinha quando conectar.</li>
        </ol>
        <div class="onb-acoes">
          <a class="onb-btn onb-btn--pri" [href]="linkExtensao" target="_blank" rel="noopener" (click)="instaleExtensao()">
            <i class="fab fa-chrome"></i> Instalar no Chrome
          </a>
          <button type="button" class="onb-btn onb-btn--sec" (click)="jaInstalei()">Já instalei</button>
          <app-onb-video passo="extensao"></app-onb-video>
        </div>
        <p class="oe-erro" *ngIf="erroExtensao">{{ erroExtensao }}</p>
      </ng-container>
    </div>
    <span class="onb-pill onb-pill--ok" *ngIf="extensaoConectada">Conectada</span>
  </div>

  <!-- impressora -->
  <div class="onb-linha oe-linha">
    <span class="onb-ic onb-ic--neutro"><i class="fas fa-print"></i></span>
    <div class="onb-tx">
      <ng-container [ngSwitch]="etapa">
        <ng-container *ngSwitchCase="'pergunta'">
          <b>Você tem impressora térmica?</b>
          <span>Aquela de cupom, que imprime o pedido para a cozinha e para o entregador.</span>
          <div class="onb-acoes">
            <button type="button" class="onb-btn onb-btn--sec" (click)="tenhoImpressora()">
              {{ conectandoQz ? 'Procurando…' : 'Tenho' }}
            </button>
            <button type="button" class="onb-btn onb-btn--link" (click)="naoTenhoImpressora()">Não tenho</button>
          </div>
        </ng-container>

        <ng-container *ngSwitchCase="'nao-tem'">
          <b>Sem impressora</b>
          <span>Tudo bem: o pedido aparece na tela. Se comprar uma, configure depois em Impressão.</span>
          <div class="onb-acoes"><button type="button" class="onb-btn onb-btn--link" (click)="mudarResposta()">Mudar</button></div>
        </ng-container>

        <ng-container *ngSwitchCase="'instalar'">
          <b>Falta o programa de impressão</b>
          <span>O navegador precisa do <b>QZ Tray</b> para falar com a impressora. É gratuito e instala uma vez só.</span>
          <ol class="oe-passos">
            <li>Baixe e instale o QZ Tray (Windows ou Mac).</li>
            <li>Abra o QZ Tray: ele fica perto do relógio do computador.</li>
            <li>Volte aqui e toque em <b>Procurar a impressora</b>.</li>
          </ol>
          <div class="onb-acoes">
            <a class="onb-btn onb-btn--pri" [href]="linkQzTray" target="_blank" rel="noopener"><i class="fas fa-download"></i> Baixar QZ Tray</a>
            <button type="button" class="onb-btn onb-btn--sec" (click)="conecteQz()">
              {{ conectandoQz ? 'Procurando…' : 'Procurar a impressora' }}
            </button>
            <button type="button" class="onb-btn onb-btn--link" (click)="abraQzTray()">Já tenho, abrir o QZ Tray</button>
            <app-onb-video passo="impressora"></app-onb-video>
          </div>
        </ng-container>

        <ng-container *ngSwitchCase="'escolher'">
          <b>Qual é a sua impressora?</b>
          <span *ngIf="impressoras.length">Escolha a térmica da lista e o tamanho do papel.</span>
          <span *ngIf="!impressoras.length">Nenhuma impressora apareceu. Confira se ela está ligada e instalada no computador.</span>
          <div class="oe-escolha" *ngIf="impressoras.length">
            <select class="onb-inp" id="onb-impressora" [(ngModel)]="impressoraEscolhida" aria-label="Impressora">
              <option value="" disabled>Escolha a impressora</option>
              <option *ngFor="let nome of impressoras" [value]="nome">{{ nome }}</option>
            </select>
            <div class="oe-papel" role="group" aria-label="Papel">
              <button type="button" [class.on]="papel === '80'" (click)="papel = '80'">80 mm</button>
              <button type="button" [class.on]="papel === '58'" (click)="papel = '58'">58 mm</button>
            </div>
          </div>
          <div class="onb-acoes">
            <button type="button" class="onb-btn onb-btn--pri" (click)="imprimaTeste()">
              <i class="fas fa-print"></i> Imprimir página de teste
            </button>
            <button type="button" class="onb-btn onb-btn--link" (click)="conecteQz()">Procurar de novo</button>
          </div>
        </ng-container>

        <ng-container *ngSwitchCase="'testando'">
          <b>Saiu a página de teste?</b>
          <span>Ela tem o nome da sua loja e um pedido de exemplo.</span>
          <div class="onb-acoes">
            <button type="button" class="onb-btn onb-btn--pri" (click)="saiu()">Saiu</button>
            <button type="button" class="onb-btn onb-btn--sec" (click)="naoSaiu()">Não saiu</button>
          </div>
        </ng-container>

        <ng-container *ngSwitchCase="'saiu'">
          <b>Impressora pronta</b>
          <span>Os pedidos aceitos saem impressos. Dá para ajustar o layout em Impressão.</span>
        </ng-container>

        <ng-container *ngSwitchCase="'falhou'">
          <b>Vamos resolver</b>
          <span>Confira: impressora ligada, com papel, luz verde acesa e cabo no computador (ou na mesma rede). O QZ Tray precisa estar aberto.</span>
          <p class="oe-erro" *ngIf="erroImpressora">{{ erroImpressora }}</p>
          <div class="onb-acoes">
            <button type="button" class="onb-btn onb-btn--sec" (click)="conecteQz()">Tentar de novo</button>
            <button type="button" class="onb-btn onb-btn--pri" (click)="pecaAjuda()"><i class="far fa-question-circle"></i> Falar com o suporte</button>
          </div>
        </ng-container>
      </ng-container>
    </div>
    <span class="onb-pill onb-pill--ok" *ngIf="etapa === 'saiu'">Pronta</span>
  </div>
</div>
<p class="onb-nota">Nada disso impede o pedido de teste. Dá para fazer depois, voltando a este passo.</p>
